module.exports = __webpack_public_path__ + "static/media/21ECLAC47.50fc83a1.jpg";